import BlogFrame from '../../components/BlogFrame';

import v15 from "../../img/renamerfx-v1.5.0.png";
import v14 from "../../img/renamerfx-v1.4.0.png";
import v13 from "../../img/renamerfx-v1.3.0.png";
import v12 from "../../img/renamerfx-v1.2.0.png";
import v11 from "../../img/renamerfx-v1.1.0.png";
import v10 from "../../img/renamerfx-v1.0.0.png";


const text = (
  <div>
    <h1>RenamerFX</h1>
    <p>GUI renamer application. Had to make one because I convert my music to 96kbps opus when putting it on phone, but Android sucks at reading the tags correctly unless file-ending is ogg, which foobar2000 doesn't allow me to set if converting to opus. Instead of writing the same PowerShell spell every time, making an app to do that makes perfect sense.</p>
    <p>Its operation is simple: it replaces string in file name, overwriting the original file and does it without second-guessing did you really mean to rename this to that there. And it does it recursively.</p>
    <p>What's nice about RenamerFX is that I made it also to be usable from command-line, providing an assisted interactive renaming or you can give it command-line args. It also ships as a completely stand-alone self-contained executable uber-jar. Only JRE required to run.</p>
    <p>RenamerFX is written in <b>Java</b> with <b>JavaFX</b> GUI library, and structured as a <b>Maven</b> project. It is licensed under GPLv3.</p>
    <br />
    <h2>Development Milestones</h2>
    <div className="slalom">
      <div>
        <div>
          <img src={v15} alt="Version 1.5" />
        </div>
        <div>
          <h4>Version 1.5</h4>
          <p>I removed the unnecessarily complex way of operating this where user first had to input directory and then select it and then tell what to do with it. Now what's in directory field is the directory to be operated in, as it was pre-1.3. I also added the directory recursion option (formerly recursed by default, bad idea).</p>
        </div>
      </div>
      <div>
        <div>
          <img src={v14} alt="Version 1.4" />
        </div>
        <div>
          <h4>Version 1.4</h4>
          <p>As I updated the project from Java 11 to Java 17, I also decided to do an overhaul on how the results are presented, changing the simple text-field to a two-column two-tone list. Legibility of the results is tremendously improved. The color experimentation is also concluded in favor of more contemporary, plain look.</p>
        </div>
      </div>
      <div>
        <div>
          <img src={v13} alt="Version 1.3" />
        </div>
        <div>
          <h5>Version 1.3</h5>
          <p>With a new feature of basic folder navigation and a milder creamy color scheme, the project gains a less harsh look and feel. Aside from background color, this is what JavaFX actually looks like by default. The previous look was also for testing what can be done with JavaFX's fxCSS.</p>
        </div>
      </div>
      <div>
        <div>
          <img src={v12} alt="Version 1.2" />
        </div>
        <div>
          <h5>Version 1.2</h5>
          <p>Major UX/UI overhaul. User can now list files in given path to make sure they are operating on correct folder, as well as preview renaming results. Even now keeping the prototype color scheme. I was considering could it be a brand look. Then I opened SumatraPDF and remembered how horrid bright yellow really looks.</p>
        </div>
      </div>
      <div>
        <div>
          <img src={v11} alt="Version 1.1" />
        </div>
        <div>
          <h5>Version 1.1</h5>
          <p>Setting elements into a better, more symmetric, more aesthetic order. More theme-like looks of strong solids instead of the dotted scaffold lines of the MVP. Still keeping the prototype color scheme.</p>
        </div>
      </div>
      <div>
        <div>
          <img src={v10} alt="Version 1.0" />
        </div>
        <div>
          <h5>Version 1.0</h5>
          <p>UI is self-explanatory. It reports current directory because input path can also be relative. Why does my version 1.0 look so... unique? Because that's what it looked like the moment it did what I needed it to do, so MVP. It's also showing how I like to visually separate all the elements with their own colors and borders during prototyping.</p>
        </div>
      </div>
    </div>
    <p>Take a look at it <a href="https://github.com/otjura/RenamerFX" target="_blank" rel="noopener noreferrer">on its GitHub page.</a> Source code of RenamerFX shows how I write, comment, structure and organize object-oriented code. I have also used the project to also experiment on different bracings and intendations, having always before used 2 or 4 space 1TBS. This was caused by exposure to Go.</p>
    <h2>Roadmap</h2>
    <p>Ever since discovering Windows PowerToys which does the renaming as I want right from file manager, RenamerFX hasn't been in active development. But there is a roadmap!</p>
    <ul className="list-disc ml-4">
      <li>replacing the static utility class with proper object</li>
      <li>upgrading from java.io.File to java.nio.Path</li>
      <li>listing directories, too, with visual separation of directories and files</li>
      <li>directory renaming</li>
      <li>enumeration</li>
      <li>regex</li>
      <li>open directory dialog (maybe javafx has one?)</li>
      <li>multithreading</li>
      <li>logging</li>
      <li>entirely self-contained distribution (modules, jlink)</li>
    </ul>
    <footer>2022</footer>
  </div >
);

export default function RenamerFX() {
  return (
    <BlogFrame text={text} />
  );
}